import React from 'react';
import {Link} from "react-router-dom";

import {sortBy} from '../util';

import SidebarNavItemArchiver from "./SidebarNavItemArchiver";
import SidebarNavItemPurger from "./SidebarNavItemPurger";

import "./SidebarNavItems.css";

const SidebarNavItems = ({list, filter, activeProjectId, handleOpenArchiveModal, handleOpenPurgeModal}) => {
  const newProject = list.filter(({id}) => id === "new");

  const activeList = [
    ...newProject,
    ...list
      .filter(({deleted, id}) => !deleted && id !== "new")
      .sort(sortBy("title"))
  ];

  const archivedList = (
    list
      .filter(({deleted, id}) => deleted && id !== "new")
      .sort(sortBy("title"))
  );

  const filteredList = filter === "archived" ? archivedList : activeList;
  
  return filteredList.map(({id, title, created_by}) => {
    const isArchivable = filter === "current" && id !== "new";
    const isPurgeable = filter === "archived";
    const isActive = activeProjectId === id;
    const clsActive = isActive ? " is-active" : "";

    const content = (
      <div
        className={`sidebar-nav-item d-flex align-items-center${clsActive}`}
        key={id}
      >
        <li className="sidebar-nav-item-text-container d-flex align-items-center">
          <p className="sidebar-nav-item-text">
            {title}
          </p>
          {
            created_by
            && (
              <p className="sidebar-nav-item-author">
                {created_by}
              </p>
            )
          }
        </li>

        {
          isArchivable
          && (
            <SidebarNavItemArchiver
              projectId={id}
              handleOpenArchiveModal={handleOpenArchiveModal}
            />
          )
        }
        
        {
          isPurgeable
          && (
            <SidebarNavItemPurger
              projectId={id}
              handleOpenPurgeModal={handleOpenPurgeModal}
            />
          )
        }
      </div>
    );

    return (
      isActive
      ? content
      : (
        <Link
          to={`/${id}`}
          key={id}
          className="sidebar-nav-item-link"
        >
          {content}
        </Link>
      )
    );
  });
};

export default SidebarNavItems;
